import { Image, Popconfirm } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { addCompareObjectAction, deleteProjectsAnalogsAction } from "../store/actions"
import Global from '../../../Global'


const serverUrl =
    process.env.NODE_ENV === "development"
        ? `${Global.SERVER_API_URL}/api`
        : `${window.location.origin}/api`


const ProjectLibraryItem = (props) => {
    const { item, isModify } = props
    const { t } = useTranslation(['common', 'manage'])
    const dispatch = useDispatch()
    const { compareObjects } = useSelector(state => state.projectReducer)

    const deleteProject = (event) => {
        dispatch(deleteProjectsAnalogsAction({ analogProjectId: item.id }))
    }

    return <div className="list__item__wrapper">
        <Link to={`/project/${item.id}`}>
            <div className="project__list__item">
                <div className="project__item__code">
                    <p>{item?.code}</p>
                </div>
                <div className="project__item__cover">
                    <Image
                        src={`${serverUrl}/JsonLine/downloadMainImage?id=${item?.id}`}
                        fallback="/defaultProjectCover.png"
                        preview={false}
                    ></Image>
                    {/* <img src={item?.img ? `${item?.img}` : '/defaultProjectCover.png'} alt="cover project" /> */}
                </div>
                <div className="project__item__name">
                    <p>{item.name}</p>
                    {item.isArchive && <p className="p-archive-red">(Архив)</p>}
                    {item.archive?.length > 0 && <p className="p-archive-red">(+ Архивы)</p>}
                </div>

            </div>
        </Link>
        <div className="project__item__manage">
            <div
                className="project__item__square"
                onClick={(e) => {
                    e.stopPropagation()
                    dispatch(addCompareObjectAction(item.analogObjectId))
                }
                }
            >
                {compareObjects?.includes(item.analogObjectId) ? <img src='/Checked.svg' alt='arrow' /> : ''}
            </div>
            {(isModify) && !item.isArchive  &&
                <div className="project__item__delete">
                    <Popconfirm
                        title={t('manage:deleteProject')}
                        okText={t('common:yes')}
                        cancelText={t('common:no')}
                        onConfirm={deleteProject}
                    >
                        <button style={{ cursor: "pointer" }} title={"Удалить проект"} onClick={(e) => e.stopPropagation()}>
                            <img src="/trash.svg" alt="trash icon" />
                        </button>
                    </Popconfirm>
                </div>}
        </div>
    </div>
}

export default ProjectLibraryItem
